import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface VoucherFinanceState {
  data: any[] | null;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allVoucherFinanceList: any[];
  approvalStatusList: any[];
  partyList: any[];   // 🔹 New: to store all parties
}

const initialState: VoucherFinanceState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allVoucherFinanceList: [],
  approvalStatusList: [],
  partyList: [],   // 🔹 initialize
};

export const voucherFinanceSlice = createSlice({
  name: "voucherFinance",
  initialState,
  reducers: {
    setVoucherFinance: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setVoucherFinanceBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setApprovalStatusList: (state, action) => {
      state.approvalStatusList = action.payload.data;
    },
    setAllVoucherFinance: (state, action) => {
      state.allVoucherFinanceList = action.payload;
    },
    setPartyList: (state, action) => {   // 🔹 New reducer
      state.partyList = action.payload.data;
    },
    resetVoucherFinance: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setVoucherFinance,
  setVoucherFinanceBySearch,
  setAllVoucherFinance,
  setApprovalStatusList,
  setPartyList,         
  resetVoucherFinance,
} = voucherFinanceSlice.actions;

// 🔹 Selectors
export const getVoucherFinanceData = (state: RootState) => state.voucherFinance.data;
export const getAllVoucherFinanceList = (state: RootState) => state.voucherFinance.allVoucherFinanceList;
export const getVoucherFinanceTotalRecords = (state: RootState) => state.voucherFinance.totalRecords;
export const getVoucherFinanceDataBySearch = (state: RootState) => state.voucherFinance.data;

export const getApprovalStatusListWithAll = (state: RootState) => [
  { id: 0, label: "All" },
  ...(state.voucherFinance.approvalStatusList || []),
];

export const getPartyListWithAll = (state: RootState) => [  
  { id: 0, label: "All" },
  ...(state.voucherFinance.partyList || []),
];

export default voucherFinanceSlice.reducer;
